///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Tunnel, TunnelReportDTO } from '../../../../../generated/shared-types.model';
import { TunnelModel } from './tunnel.model';

export class ExtendedTunnelReportDTO implements TunnelReportDTO {
    buLocationsWithSingleTunnel: string[];
    buLocationsWithoutTunnels: string[];
    buMustLocationsWithoutBuDevices: string[];
    /**
     @deprecated The tunnels field should not be used, use tunnelModels instead
     */
    tunnels: Tunnel[];
    tunnelModels: TunnelModel[];
}
